import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import DateInput from "components/Input/DateInput.js";
import IntInput from "components/Input/IntInput.js";
import { CustomSelect } from "components/Input/Index.js";
import UserService from "services/UserService";
import { makeStyles, withStyles } from "@mui/styles";
import { getSite, postTertiaryBill } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { declapage, declaconsobycategory } from "variables/tertiaryBill";
import { yeardata } from "variables/lists/tertiarybill";
import { NotificationManager } from 'react-notifications';
import CustomSwitch from "components/Input/CustomSwitch.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import DeclarationDialog from "./DeclarationDialog";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  getdataButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "1ch",
    width: "50ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
    "&:focus": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  getdataButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "1ch",
    width: "50ch",
    "&:focus": {
      backgroundColor: "#9798A0",
    },
  },
  declaButton: {
    color: "#FFFFFF",
    backgroundColor: "#3E8FC6",
    fontWeight: "bold",
    display: "block",
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "1ch",
    width: "50ch",
    "&:hover": {
      backgroundColor: "#3E8FC6",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
    "&:focus": {
      backgroundColor: "#3E8FC6",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  declaButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "1ch",
    width: "50ch",
  },
}));

const ResultsDiv = styled.div`
  display: flex;
`;

export default function Declaration(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupAccountListById } = appContext;

  const [getdatabuttondisabled, setGetdatabuttondisabled] = useState(true);
  const [declabuttondisabled, setDeclabuttondisabled] = useState(true);
  const [getdatatext, setGetdatatext] = useState("");
  const [getdatacolor, setGetdatacolor] = useState("");
  const [resultsToDownload, setResultsToDownload] = useState(false);
  const [getdataresults, setGetdataresults] = useState([]);

  const [openDeclarationDialog, setOpenDeclarationDialog] = useState(false);

  const [tertiarybill, setTertiarybill] = useState("");

  const [consocategory, setConsocategory] = useState("indi");
  const [consocategorydata, setConsocategorydata] = useState([]);
  const [year, setYear] = useState("REFERENCE");
  const [declaration, setDeclaration] = useState("");
  const [electricityconsumptionvar, setelectricityconsumptionvar] = useState("consoIndiHorsIRVEKWh");
  const [gasconsumptionvar, setgasconsumptionvar] = useState("consoIndiGazNatReseauxKWh");
  const [liquidgasconsumptionvar, setliquidgasconsumptionvar] = useState("consoIndiGazNatLiquefieKg");
  const [propanem3consumptionvar, setpropanem3consumptionvar] = useState("consoIndiGazPropaneM3");
  const [propanekgconsumptionvar, setpropanekgconsumptionvar] = useState("consoIndiGazPropaneKg");
  const [butanem3consumptionvar, setbutanem3consumptionvar] = useState("consoIndiGazButaneM3");
  const [butanekgconsumptionvar, setbutanekgconsumptionvar] = useState("consoIndiGazButaneKg");
  const [fuelconsumptionvar, setfuelconsumptionvar] = useState("consoIndiFioulDomestiLitre");
  const [coalconsumptionvar, setcoalconsumptionvar] = useState("consoIndiCharbonAggloBriqKg");
  const [houilleconsumptionvar, sethouilleconsumptionvar] = useState("consoIndiHouilleKg");
  const [industrywoodconsumptionvar, setindustrywoodconsumptionvar] = useState("consoIndiBoisPlaqIndustrieKg");
  const [forestwoodconsumptionvar, setforestwoodconsumptionvar] = useState("consoIndiBoisPlaqForestKg");
  const [granulewoodconsumptionvar, setgranulewoodconsumptionvar] = useState("consoIndiBoisGranBriqKg");
  const [logwoodconsumptionvar, setlogwoodconsumptionvar] = useState("consoIndiBoisBuchesStere");
  const [heatnetworkconsumptionvar, setheatnetworkconsumptionvar] = useState("consoIndiReseauChaleurKWh");
  const [coldnetworkconsumptionvar, setcoldnetworkconsumptionvar] = useState("consoIndiReseauFroidKWh");

  console.log(declaration);
  useEffect(() => {
    if (!year || !tertiarybill?.idefaoperat || declaration[year]?.declaredonOperat) {
      setGetdatabuttondisabled(true);
      setDeclabuttondisabled(true);
    }
    else {
      setGetdatabuttondisabled(false);
      setDeclabuttondisabled(false);
    }
  }, [year, tertiarybill?.idefaoperat, declaration[year]?.declaredonOperat]);

  const handleGetYearData = async (event) => {
    setGetdatabuttondisabled(true);
    setDeclabuttondisabled(true);
    setGetdatacolor("#FF763A");
    setResultsToDownload(false);
    setGetdatatext(declapage.waitforgetresult);
    axios
      .post(
        postTertiaryBill("getdecla"),
        {
          year,
          idefaoperat: tertiarybill.idefaoperat,
          account: groupAccountListById["" + chartIdGroup]
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status === 'success') {
            setGetdatacolor("#91C73C");
            setGetdatatext(declapage.getdatasuccess);
            let detail = res.data.consommationsresponse.detail;
            let newdeclaration = { ...declaration };
            if (!newdeclaration[year])
              newdeclaration[year] = {};
            Object.keys(detail).forEach((key) => {
              if (key === 'anneeDeclaree') {
                newdeclaration[year].declaredonOperat = true;
              }
              else if (key === 'categorieActivitePrincipale') {

              }
              else if (key === 'activites') {

              }
              else if (key === 'consoId') {

              }
              else if (key === 'dateDebutConsoReference' && year === 'REFERENCE') {
                console.log(detail[key]);
                let tab = detail[key].split("/");
                console.log(tab);
                let startmonth = tab[1].replace('\\', '');
                let startyear = tab[2].replace('\\', '');
                console.log(startmonth, startyear);
                newdeclaration[year].startdate = startyear + '-' + startmonth;
              }
              else if (key === 'indicateurs') {

              }
              else if (key === 'stationMeteoEfa') {

              }
              else if (key === 'refOperatEfa') {

              }
              else {
                if (detail[key])
                  newdeclaration[year][key] = detail[key];
              }
            });
            // let exportarray = [];
            // exportarray = testresults_tmp.map((item) => {
            //   let efatoexport = {};
            //   efatoexport[comptepage.adresseEfa] = (item.adresseEfa?.numeroNomVoie + ", " || "") + (item.adresseEfa?.codePostal + " " || "") + (item.adresseEfa?.commune + " " || "");
            //   efatoexport[comptepage.complementNomEfa] = (item.complementNomEfa || "");
            //   efatoexport[comptepage.denominationOccupantEfa] = (item.denominationOccupantEfa || "");
            //   efatoexport[comptepage.idOccupantEfa] = (item.idOccupantEfa || "");
            //   efatoexport[comptepage.refOperatEfa] = (item.refOperatEfa || "");
            //   efatoexport[comptepage.typeOccupantEfa] = (item.typeOccupantEfa || "");
            //   return efatoexport;
            // });
            // setGetdataresults(exportarray);
            setDeclaration(newdeclaration);
            setResultsToDownload(true);
          }
          else {
            setGetdatacolor("#C53F3F");
            setGetdatatext(declapage.getdataerror);
          }
        }
        else if (res.status == 400) {
          setGetdatatext("");
          // setGetdatabuttondisabled(false);
          NotificationManager.error(res.data);
        }
        else {
          setGetdatatext("");
          // setGetdatabuttondisabled(false);
          NotificationManager.error("Une erreur est survenue");
        }

      })
      .catch((err) => {
        setGetdatatext("");
        console.log(err);
        // setGetdatabuttondisabled(false);
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const handleDecla = (event) => {
    setOpenDeclarationDialog(true);
  }
  const handleCloseDecla = (event) => {
    setOpenDeclarationDialog(false);
  }
  const refreshDeclaration = () => {

  }

  const handleYearChange = (event) => {
    setYear(event.target.value);
    //setConsocategory("indi");
  };
  const handleConsocategoryChange = (event) => {
    setConsocategory(event.target.value);
    setelectricityconsumptionvar(declaconsobycategory[event.target.value].electricityconsumption);
    setgasconsumptionvar(declaconsobycategory[event.target.value].gasconsumption);
    setliquidgasconsumptionvar(declaconsobycategory[event.target.value].liquidgasconsumption);
    setpropanem3consumptionvar(declaconsobycategory[event.target.value].propanem3consumption);
    setpropanekgconsumptionvar(declaconsobycategory[event.target.value].propanekgconsumption);
    setbutanem3consumptionvar(declaconsobycategory[event.target.value].butanem3consumption);
    setbutanekgconsumptionvar(declaconsobycategory[event.target.value].butanekgconsumption);
    setfuelconsumptionvar(declaconsobycategory[event.target.value].fuelconsumption);
    setcoalconsumptionvar(declaconsobycategory[event.target.value].coalconsumption);
    sethouilleconsumptionvar(declaconsobycategory[event.target.value].houilleconsumption);
    setindustrywoodconsumptionvar(declaconsobycategory[event.target.value].industrywoodconsumption);
    setforestwoodconsumptionvar(declaconsobycategory[event.target.value].forestwoodconsumption);
    setgranulewoodconsumptionvar(declaconsobycategory[event.target.value].granulewoodconsumption);
    setlogwoodconsumptionvar(declaconsobycategory[event.target.value].logwoodconsumption);
    setheatnetworkconsumptionvar(declaconsobycategory[event.target.value].heatnetworkconsumption);
    setcoldnetworkconsumptionvar(declaconsobycategory[event.target.value].coldnetworkconsumption);
  };
  const handleDeclarationChange = (event, key) => {
    let newdeclaration = { ...declaration };
    if (!newdeclaration[year])
      newdeclaration[year] = {};
    newdeclaration[year][key] = event.target.value;
    setDeclaration(newdeclaration);
  };
  const handleDeclaredonOperatChange = (event) => {
    let newdeclaration = { ...declaration };
    if (!newdeclaration[year])
      newdeclaration[year] = {};
    newdeclaration[year].declaredonOperat = !newdeclaration[year].declaredonOperat;
    setDeclaration(newdeclaration);
  };

  const handleEdit = async (event) => {
    axios
      .put(
        getSite(chartIdGroup, "tertiarybill"),
        {
          ...tertiarybill,
          declaration,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "tertiarybill"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setTertiarybill(res.data.detail.tertiarybill || {});
        setDeclaration(res.data.detail.tertiarybill?.declaration || {});
        let consocategorydatatmp = [];
        consocategorydatatmp.push({ id: 'indi', name: "Consommation individuelle de l'EFA" });
        if (res.data.detail.tertiarybill?.consorep)
          consocategorydatatmp.push({ id: 'rep', name: "Consommation répartie de l'EFA" });
        if (res.data.detail.tertiarybill?.consocom)
          consocategorydatatmp.push({ id: 'com', name: "Consommation des espaces communs de l'EFA" });
        if (res.data.detail.tertiarybill?.categories?.find((category) => category.heating))
          consocategorydatatmp.push({ id: 'chauff', name: "Consommation pour le chauffage de l'EFA" });
        if (res.data.detail.tertiarybill?.categories?.find((category) => category.cooling))
          consocategorydatatmp.push({ id: 'refroidissement', name: "Consommation pour le refroidissement de l'EFA" });
        if (res.data.detail.tertiarybill?.categories?.find((category) => category.coollog))
          consocategorydatatmp.push({ id: 'froidLogist', name: "Consommation pour la logistique du froid de l'EFA" });
        if (res.data.detail.tertiarybill?.categories?.find((category) => category.coolcom))
          consocategorydatatmp.push({ id: 'froidCom', name: "Consommation pour le froid commercial de l'EFA" });
        if (res.data.detail.tertiarybill?.categories?.find((category) => category.consdoc))
          consocategorydatatmp.push({ id: 'conservationDoc', name: "Consommation pour la conservation de documents ou collections de l'EFA" });
        setConsocategorydata(consocategorydatatmp);
      });
  }, []);

  const classes = useStyles();

  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <CustomSelect
              inputTitle={declapage.yearchoice}
              selectValue={year}
              handleSelectValueChange={handleYearChange}
              data={yeardata}
            />
          </div>
          <div>
            <Button
              disabled={getdatabuttondisabled}
              className={
                getdatabuttondisabled
                  ? classes.getdataButtonDisabled
                  : classes.getdataButton
              }
              onClick={() => {
                handleGetYearData();
              }}
            >
              {declapage.getdatabutton}
            </Button>
          </div>
          <div>
            <Button
              disabled={declabuttondisabled}
              className={
                declabuttondisabled
                  ? classes.declaButtonDisabled
                  : classes.declaButton
              }
              onClick={() => {
                handleDecla();
              }}
            >
              {declapage.declareconsumtion}
            </Button>
          </div>
          <ResultsDiv>
            {/* {
              resultsToDownload ?
                <ExportTableToCSV dataarray={getdataresults} />
                : <></>
            } */}
            <div style={{ color: "" + getdatacolor, marginTop: "8px", marginLeft: "10px", fontWeight: "bold" }}>{getdatatext}
            </div>
          </ResultsDiv>
          <div>
            <CustomSwitch
              disabled={!realestateupdate}
              inputTitle={declapage.declaredonOperat}
              checkedState={declaration[year]?.declaredonOperat || false}
              handleSwitchChange={handleDeclaredonOperatChange} />
          </div>
          {
            year === 'REFERENCE' ?
              <div>
                <DateInput
                  inputTitle={declapage.startdate}
                  dateInput={declaration[year]?.startdate || ''}
                  handleDateInputChange={(event) => handleDeclarationChange(event, 'startdate')}
                  specialType={"month"}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div>
              : <></>
          }
          {/* <div>
            <IntInput
              inputTitle={declapage.dju}
              intInput={declaration[year]?.dju || ''}
              handleIntInputChange={(event) => handleDeclarationChange(event, 'dju')}
              disabled={!realestateupdate}
            />
          </div> */}
          <div>
            <IntInput
              inputTitle={declapage.vehiElecConsoAvcIRVEKWh}
              intInput={declaration[year]?.vehiElecConsoAvcIRVEKWh || ''}
              handleIntInputChange={(event) => handleDeclarationChange(event, 'vehiElecConsoAvcIRVEKWh')}
              disabled={!realestateupdate || declaration[year]?.declaredonOperat}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={declapage.consocategory}
              selectValue={consocategory}
              handleSelectValueChange={handleConsocategoryChange}
              data={consocategorydata}
             // disabled={!realestateupdate || declaration[year]?.declaredonOperat}
            />
          </div>
          {
            consocategory === 'froidLogist' ?
              <div>
                <IntInput
                  inputTitle={declapage.froidLogistHauteurRefroidie}
                  intInput={declaration[year] ? declaration[year].froidLogistHauteurRefroidie || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, declaration[year].froidLogistHauteurRefroidie)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div>
              : <></>
          }
          {
            tertiarybill.consoelec ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.electricityconsumption}
                  intInput={declaration[year] ? declaration[year][electricityconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, electricityconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div>
              : <></>
          }
          {
            tertiarybill.consogaznatreseau ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.gasconsumption}
                  intInput={declaration[year] ? declaration[year][gasconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, gasconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consogaznatliq ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.liquidgasconsumption}
                  intInput={declaration[year] ? declaration[year][liquidgasconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, liquidgasconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consogazprop ?
              <>
                <div>
                  <IntInput
                    inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.propanem3consumption}
                    intInput={declaration[year] ? declaration[year][propanem3consumptionvar] || '' : ''}
                    handleIntInputChange={(event) => handleDeclarationChange(event, propanem3consumptionvar)}
                    disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                  />
                </div>
                <div>
                  <IntInput
                    inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.propanekgconsumption}
                    intInput={declaration[year] ? declaration[year][propanekgconsumptionvar] || '' : ''}
                    handleIntInputChange={(event) => handleDeclarationChange(event, propanekgconsumptionvar)}
                    disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                  />
                </div></>
              : <></>
          }
          {
            tertiarybill.consogazbut ?
              <>
                <div>
                  <IntInput
                    inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.butanem3consumption}
                    intInput={declaration[year] ? declaration[year][butanem3consumptionvar] || '' : ''}
                    handleIntInputChange={(event) => handleDeclarationChange(event, butanem3consumptionvar)}
                    disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                  />
                </div>
                <div>
                  <IntInput
                    inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.butanekgconsumption}
                    intInput={declaration[year] ? declaration[year][butanekgconsumptionvar] || '' : ''}
                    handleIntInputChange={(event) => handleDeclarationChange(event, butanekgconsumptionvar)}
                    disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                  />
                </div></>
              : <></>
          }
          {
            tertiarybill.consofiouldom ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.fuelconsumption}
                  intInput={declaration[year] ? declaration[year][fuelconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, fuelconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consocharbonagglo ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.coalconsumption}
                  intInput={declaration[year] ? declaration[year][coalconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, coalconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consohouille ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.houilleconsumption}
                  intInput={declaration[year] ? declaration[year][houilleconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, houilleconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consoboisplaqind ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.industrywoodconsumption}
                  intInput={declaration[year] ? declaration[year][industrywoodconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, industrywoodconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consoboisplaqfor ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.forestwoodconsumption}
                  intInput={declaration[year] ? declaration[year][forestwoodconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, forestwoodconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consoboisgran ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.granulewoodconsumption}
                  intInput={declaration[year] ? declaration[year][granulewoodconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, granulewoodconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consoboisbuche ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.logwoodconsumption}
                  intInput={declaration[year] ? declaration[year][logwoodconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, logwoodconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consoreseauchal ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.heatnetworkconsumption}
                  intInput={declaration[year] ? declaration[year][heatnetworkconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, heatnetworkconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
          {
            tertiarybill.consoreseaufrois ?
              <div>
                <IntInput
                  inputTitle={consocategorydata.find((x) => x.id === consocategory) && consocategorydata.find((x) => x.id === consocategory).name + declapage.coldnetworkconsumption}
                  intInput={declaration[year] ? declaration[year][coldnetworkconsumptionvar] || '' : ''}
                  handleIntInputChange={(event) => handleDeclarationChange(event, coldnetworkconsumptionvar)}
                  disabled={!realestateupdate || declaration[year]?.declaredonOperat}
                />
              </div> : <></>
          }
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>
      <Dialog
        onClose={handleCloseDecla}
        aria-labelledby="addMarket-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={openDeclarationDialog}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseDecla}>
          {declapage.declareconsumptiontitle + yeardata.find((yd)=>yd.id===year)?.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <DeclarationDialog
            closeModal={handleCloseDecla}
            refetch={refreshDeclaration}
            tertiarybill={tertiarybill}
            currentyear={year}
            declaration={declaration}
            consocategorydata={consocategorydata}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
    </div>
  );
}
